module.exports = __webpack_public_path__ + "img/厦门理研.png";